<script>
import {resetObject, setObject} from '../../common/util';
export default {
  created() {
  },
  props: {
      title: {
          type: String,
          required: true
      },
      dialogWidth: {
          type: String,
          default: () => '50%'
      },
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      codeDetail: {
          type: Object
      },
      editOption: {
          type: Object
      }
  },
  data() {
      return {
          auth: {
              name: '',
              code: '',
              shortCode: ''
          },
          editQuery: {
              name: '',
              remark: ''
          },
          options: [{
				value: '选项1',
				label: '黄金糕'
				}, {
				value: '选项2',
				label: '双皮奶'
			}],
        data: [{
          id: 1,
          label: '一级 1',
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }, {
          id: 2,
          label: '一级 2',
          children: [{
            id: 5,
            label: '二级 2-1'
          }, {
            id: 6,
            label: '二级 2-2'
          }]
        }, {
          id: 3,
          label: '一级 3',
          children: [{
            id: 7,
            label: '二级 3-1'
          }, {
            id: 8,
            label: '二级 3-2'
          }]
        }],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
  },
  methods: {
      initQuery(row) {
          const type = this.editOption.type;
          Object.is(type, 0) && setObject(this.editQuery, row);
      },
      async submit() {
        const params = this.editOption.row ? {...this.codeQuery, id: this.editOption.row.id} : this.codeQuery;
        const {status} = await this.codeEvent(params);
        console.log(status);
        if (Object.is(status, 0)) {
            this.searchEvent();
            this.$message.success(`${this.title}成功`);
        }
        this.editOption.dialog = false;
        resetObject(this.codeQuery);
      }
  },
  mounted() {
  },
  computed: {
  },
}
</script>
<template>
<div class="edit">
  <el-dialog v-if="editOption.type===0"
    title="菜单权限编辑"
    :visible.sync="editOption.dialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-tree
        :data="data"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps">
    </el-tree>
    <div slot="footer" class="dialog-footer">
          <el-button @click="editOption.dialog = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submit" size="small"
         >提交</el-button>
    </div>
</el-dialog>
<el-dialog v-if="editOption.type===1"
    title="编辑"
    :width="dialogWidth"
    :visible.sync="editOption.dialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="codeQuery" ref="information">
      <el-form-item label="权限名称" label-width="80px">
          <el-select v-model="editQuery.name" class="common-width9" placeholder="权限名称">
             <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
             >
             </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="备注" label-width="80px">
          <el-input v-model="editQuery.editQuery" 
            class="common-width9"
            type="textarea"
            :rows="3"
          ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="editOption.dialog = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submit" size="small"
         >提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">

</style>